<template>
    <div>
        <BaseDatatable :module="`categories`" :apiurl="url" :fields="fields"></BaseDatatable>
    </div>
</template>

<script>
import BaseDatatable from '../../core/BaseDatatable'

export default {
  name: 'CategoryList',
  props: ['url'],
  components: {BaseDatatable},
  data () {
    return {
      apiurl: this.url,
      fields: [
        {
          name: 'name',
          sortField: 'name',
          title: this.$translate.t('Name')
        },
        {
          name: 'url',
          sortField: 'url',
          title: this.$translate.t('Url')
        },
        {
          name: '__slot:actions',
          title: this.$translate.t('Actions')
        }
      ],
      roles: {},
      page: 1,
      filters: {}
    }
  },
  created: function () {
    this.$emit('updateTitle', this.$translate.t('Category List'))
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/category/CategoryList.vue